export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21 8h-1.574l-.929 12.077A1 1 0 0117.5 21h-11a1 1 0 01-.997-.923L4.574 8H3V6h18v2zM7.426 19h9.148l.846-11H6.58l.846 11z\" fill=\"#7B61FF\"/><path d=\"M12 2c1.173 0 2.075.294 2.697.605.31.155.548.313.715.439a3.444 3.444 0 01.26.215l.02.02.01.008.002.003.002.001-1.412 1.417.01.01-.01-.008a1.357 1.357 0 00-.081-.066 2.711 2.711 0 00-.41-.25C13.425 4.207 12.827 4 12 4s-1.425.206-1.803.395c-.19.095-.327.187-.41.249a1.36 1.36 0 00-.082.066l-.01.009.011-.011-1.412-1.416.005-.005.009-.008.02-.02.06-.055a3.46 3.46 0 01.2-.16c.167-.126.405-.284.715-.439C9.925 2.295 10.827 2 12 2z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};